<template>
  <div class="qe-aside-p">
    <div class="qe-aside-node-p" @click="scrollToNode">
      <div></div>
      <p>节点</p>
    </div>
    <div class="qe-aside-quality-p" @click="scrollToQuality">
      <div></div>
      <p>质量安全</p>
    </div>
    <div class="qe-aside-material-p" @click="scrollToMaterial">
      <div></div>
      <p>材料安全</p>
    </div>
    <div class="qe-aside-comment-p" @click="scrollToComment">
      <div></div>
      <p>评论</p>
    </div>
    <div class="qe-aside-liked-p" @click="like" :class="{active:isLiked}">
      <div></div>
      <p>点赞</p>
    </div>
    <div class="qe-aside-top-p" @click="scrollToTop">
      <img src="../../../../../html/pages/originality/createQe/images/arrow1.png" alt />
    </div>
  </div>
</template>

<script>
import "../../../../../html/components/postDetail/qeAsideRight.scss"

import { like } from "../../../../../api/index"

export default {
  name: 'qeAsideRight',
  data() {
    return {
      isLiked:false,
    }
  },
  props:{
    isLike:{
      type:Boolean,
      default:false
    }
  },
  watch:{
    isLike(n){
      this.isLiked = n
    }
  },
  methods: {
    scrollToNode() {
      this.$emit("scrollToNode")
    },
    scrollToQuality() {
      this.$emit("scrollToQuality")
    },
    scrollToMaterial() {
      this.$emit("scrollToMaterial")
    },
    scrollToComment() {
      this.$emit("scrollToComment")
    },
    scrollToTop() {
      this.$emit("scrollToTop")
    },
    async like() {
      let res = await like({
        id: this.$route.params.id
      })
      if (res.type = "Success") {
        if (res.Content.indexOf('点赞') > -1) {
          this.isLiked = true
        } else if (res.Content.indexOf('取消') > -1) {
          this.isLiked = false
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
